// Don't export the original components directly to avoid React 19 compatibility issues
export * from "./Slider";


// Re-export types for convenience
export type { ReactSliderProps } from "react-slider";
